//@flow

class FrameLoader {
  addFrame(frameId:string, src:?string, callback?:() => void) {
    if (global.inServer || document.getElementById(frameId) || !src) return;

    const frame:HTMLIFrameElement = document.createElement('iframe');
    frame.scrolling = 'no';
    frame.frameBorder = '0';
    frame.width = '1';
    frame.height = '1';
    frame.src = src;
    frame.id = frameId;
    frame.title = frameId;
    if (callback) frame.onload = callback;
    document && document.body && document.body.appendChild(frame);
  }
}

export default new FrameLoader();
